<span class="badge"
  [ngClass]="type">
  <ng-content></ng-content>
</span>
